import Climate from "./Climate"
import Moment from "./Moment"
import PerformanceProfiles from "./PerformanceProfiles"
import Period from "./Period"
import Season from "./Season"
import Temperature from "./Temperature"
import Totals from "./Totals"

const clone = (obj) => JSON.parse(JSON.stringify(obj));

export const IndexesTab = ({ stats = {}, selected_filters = {}, onSelectFilters = null}) => {

    const selectFilters = (group, variable) => {
        const filters = clone(selected_filters) || {};
        filters[group] = filters?.[group] || [];

        const index = filters[group].indexOf(variable);

        if (index !== -1) {
            filters[group].splice(index, 1);
        } else {
            filters[group].push(variable);
        }

        onSelectFilters && onSelectFilters(filters);
    }

    console.log(selected_filters)

    return (
        <>
            {/* <Totals totals={stats?.general} /> */}
            <PerformanceProfiles
                onSelectFilters={(filters) => selectFilters('c.rfv_profile', filters)}
                filters={selected_filters?.['c.rfv_profile'] || []}
                rfv_profile={stats?.rfv}
            />
            <Climate
                onSelectFilters={(filters) => selectFilters('c.tag_climate', filters)}
                filters={selected_filters?.['c.tag_climate'] || []}
                customers={stats?.customers | 0}
                tags={stats?.tags?.climate}
            />
            <Moment
                onSelectFilters={(filters) => selectFilters('c.tag_period_week', filters)}
                filters={selected_filters?.['c.tag_period_week'] || []}
                customers={stats?.customers | 0}
                tags={stats?.tags?.week}
            />
            <Period
                onSelectFilters={(filters) => selectFilters('c.tag_period_day', filters)}
                filters={selected_filters?.['c.tag_period_day'] || []}
                customers={stats?.customers | 0}
                tags={stats?.tags?.day}
            />
            <Season
                onSelectFilters={(filters) => selectFilters('c.tag_period_year', filters)}
                filters={selected_filters?.['c.tag_period_year'] || []}
                customers={stats?.customers | 0}
                tags={stats?.tags?.year}
            />
            <Temperature
                onSelectFilters={(filters) => selectFilters('c.tag_temperature', filters)}
                filters={selected_filters?.['c.tag_temperature'] || []}
                customers={stats?.customers | 0}
                tags={stats?.tags?.temperature}
            />
        </>
    )
}